export default "__VITE_ASSET__Du6lPuOS__"